import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as HttpStatus from 'http-status-codes';
import { Subscription } from 'rxjs/Subscription';
import { CommissionStore } from '../service';

@Component({
  selector: 'pioneer-payment-error',
  templateUrl: './payment-error.component.html',
})
export class PaymentErrorComponent implements OnInit, OnDestroy {

  private subscription: Subscription = new Subscription();

  errorTitle: string;
  errorSummary: string;

  constructor(
    private commissionStore: CommissionStore,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.subscription.add(
      this.commissionStore.errorResponse.subscribe(errorResponse => {
        if (errorResponse) {
          if (errorResponse.status === HttpStatus.BAD_REQUEST) {
            this.errorTitle = this.translate.instant('EVENT.COMMISSION.RESPONSE_SUBMITTED_TITLE');
            this.errorSummary = this.translate.instant('EVENT.COMMISSION.RESPONSE_SUBMITTED_SUMMARY');
          } else {
            this.errorTitle = this.translate.instant('EVENT.COMMISSION.INVALID_LINK_TITLE');
            this.errorSummary = this.translate.instant('EVENT.COMMISSION.INVALID_LINK_SUMMARY');
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-error/payment-error.component.ts